unit Essentials.Web.Manager;

interface

uses
  System.Generics.Collections,
  Data.DB,
  XData.Web.Client,
  XData.Web.Dataset,
  WEBlib.Forms,
  WEBLib.DBCtrls,
  JS,
  Essentials.Shared{,
  Aurelius.Mapping.Explorer};

type

  TEssentialsLookupManager = class
  private
    FWebClient: TXDataWebClient;
    FLookupDataset: TXDataWebDataset;
    FLookupValuesDataset: TXDataWebDataset;
    FRegisteredEntities: TList<TdtoLookupDef>;
    procedure CreateDatasets;
    [Async]
    procedure Load; async;
    [Async]
    procedure LoadLookups; async;
    [Async]
    procedure LoadRegisteredEntities; async;
    [Async]
    procedure LoadLookupValueData; async;
    procedure ValuesNewRecord(DataSet: TDataSet);
    procedure SetWebClient(const Value: TXDataWebClient);
    function GetRegisteredFields(const AClassName: string): TList<string>;
  public
    constructor Create;
    destructor Destroy; override;
    [Async]
    function SaveLookupChanges: Boolean; async;
    [Async]
    function SaveValueChanges: Boolean; async;
    [Async]
    function LocateLookup(const EntityClassName, FieldName: string): Boolean; async;
    [Async]
    procedure LoadLookupCombos(AForm: TForm); async;
    [Async]
    procedure LoadCombo(ACtrl: TDBComboBox); async;

    property WebClient: TXDataWebClient read FWebClient write SetWebClient;
    property RegisteredEntities: TList<TdtoLookupDef>read FRegisteredEntities;
    property RegisteredFields[const EntityClassName: string]: TList<string>read GetRegisteredFields;
    property LookUpDataset: TXDataWebDataset read FLookupDataset;
    property LookUpValuesDataset: TXDataWebDataset read FLookupValuesDataset;

  end;

  TEssentialsAttributesManager = class
  private
    FWebClient: TXDataWebClient;
    FAttributesDefinitionsDataset: TXDataWebDataset;
    FSelectedEntity: string;
    FRegisteredEntities: TList<TdtoLookupDef>;
    [Async]
    procedure Load; async;
    [Async]
    procedure LoadAttributeDefinitions; async;
    [Async]
    procedure LoadRegisteredEntities; async;
    procedure CreateDatasets;
    procedure SetWebClient(const Value: TXDataWebClient);
    function GetRegisteredFields(const EntityClassName: string): TList<string>;
    procedure DefinitionsNewRecord(Dataset: TDataSet);
  public
    [Async]
    function LocateAttributeDefinitions(const EntityClassName: string): Boolean; async;
    [Async]
    function SaveAttributeDefinitionChanges: Boolean; async;
    constructor Create;
    destructor Destroy; override;
    property WebClient: TXDataWebClient read FWebClient write SetWebClient;
    property RegisteredEntities: TList<TdtoLookupDef>read FRegisteredEntities;
    property RegisteredFields[const EntityClassName: string]: TList<string> read GetRegisteredFields;
    property AttributesDefinitionsDataset: TXDataWebDataset read FAttributesDefinitionsDataset;
    property SelectedEntity: string read FSelectedEntity write FSelectedEntity;
  end;

  TCustomNamesManager = class
  private
    FWebClient: TXDataWebClient;
    FNamesDataset: TXDataWebDataset;
    FRegisteredEntities: TList<TdtoLookupDef>;
    procedure CreateDataset;
    [Async]
    procedure LoadRegisteredEntities; async;
    [Async]
    procedure Load; async;
    procedure SetWebClient(const Value: TXDataWebClient);
    function GetRegisteredFields(const EntityClassName: string): TList<string>;
  public
    constructor Create;
    destructor Destroy; override;
    [Async]
    function SaveChanges: Boolean; async;
    [Async]
    procedure SetCustomLabels(AForm: TForm); async;
    [Async]
    procedure SetCustomTableTitles(const ATable: TDBTableControl); async;
    function EntityCustomName(const EntityClassName: string): string;
    function EntityFieldName(const EntityClassName, FieldName: string): string;
    property WebClient: TXDataWebClient read FWebClient write SetWebClient;
    property NamesDataset: TXDataWebDataset read FNamesDataset write FNamesDataset;
    property RegisteredEntities: TList<TdtoLookupDef>read FRegisteredEntities;
    property RegisteredFields[const EntityClassName: string]: TList<string>read GetRegisteredFields;
  end;

  TNotesManager = class
  private
    FWebClient: TXDataWebClient;
    procedure SetWebClient(const Value: TXDataWebClient);
  public
    [Async]
    function GetNoteData(const ANoteId: Integer): string; async;
    [Async]
    function SaveNoteData(const ANoteId: Integer; const ANote: string): string; async;
    property WebClient: TXDataWebClient read FWebClient write SetWebClient;
  end;

  TEssentialsManager = class
  private
    FWebClient: TXDataWebClient;
    FLookupManager: TEssentialsLookupManager;
    FCustomNamesManager: TCustomNamesManager;
    FNotesManager: TNotesManager;
    FAttributesManager: TEssentialsAttributesManager;
    procedure SetWebClient(const Value: TXDataWebClient);
  public
    constructor Create;
    destructor Destroy; override;
    [Async]
    procedure FormSetUp(AForm: TForm); async;
    property WebClient: TXDataWebClient read FWebClient write SetWebClient;
    property LookUpManager: TEssentialsLookupManager read FLookupManager;
    property CustomNamesManager: TCustomNamesManager read FCustomNamesManager;
    property NotesManager: TNotesManager read FNotesManager;
    property AttributesManager: TEssentialsAttributesManager read FAttributesManager;
  end;

implementation

uses
  System.Types,
  System.SysUtils,
  System.Variants,
  XData.Web.JsonDataset,
  SMX.Web.Utils,
  XData.Dataset.Utils,
  SMX.XDataSvc.Utils,
  SMX.Web.Document.Utils, TypInfo;

{ TEssentialsManager }

constructor TEssentialsManager.Create;
begin
  FLookupManager := TEssentialsLookupManager.Create;
  FCustomNamesManager := TCustomNamesManager.Create;
  FNotesManager := TNotesManager.Create;
  FAttributesManager := TEssentialsAttributesManager.Create;
end;

destructor TEssentialsManager.Destroy;
begin
  FNotesManager.Free;
  FCustomNamesManager.Free;
  FLookupManager.Free;
  FAttributesManager.Free;
  inherited;
end;

procedure TEssentialsManager.FormSetUp(AForm: TForm);
var
  I: Integer;
  C, S: string;
begin
  for I := 0 to Aform.ControlCount - 1 do
  begin
    C := AForm.controls[I].ClassName;
    S := AForm.controls[I].Name;
    if (AForm.controls[I] is TDBComboBox) then
      FLookupManager.LoadCombo(TDBComboBox(AForm.controls[I]));
    if AForm.Controls[I] is TDBTableControl then
      FCustomNamesManager.SetCustomTableTitles(TDBTableControl(AForm.Controls[I]));
  end;
  //  Await(FLookupManager.LoadLookupCombos(AForm));

  Await(FCustomNamesManager.SetCustomLabels(AForm));
end;

procedure TEssentialsManager.SetWebClient(const Value: TXDataWebClient);
begin
  FWebClient := Value;
  if Assigned(FWebClient) then
  begin
    FLookupManager.WebClient := FWebClient;
    FNotesManager.WebClient := FWebClient;
    FCustomNamesManager.WebClient := FWebClient;
    FAttributesManager.WebClient := FWebClient;
  end;
end;

{ TEssentialsLookupManager }

constructor TEssentialsLookupManager.Create;
begin
  CreateDatasets;

end;

procedure TEssentialsLookupManager.CreateDatasets;
var
  Field: TField;
begin

  if not Assigned(FLookupDataset) then
  begin
    FLookupDataset := TXDataWebDataset.Create(nil);
    FLookupDataset.EntitySetName := 'sxeLookup';

    Field := TIntegerField.Create(FLookupDataset);
    Field.FieldName := 'Id';
    Field.DataSet := FLookupDataset;

    Field := TStringField.Create(FLookupDataset);
    Field.FieldName := 'EntityClassName';
    Field.Size := 64;
    Field.DataSet := FLookupDataset;
    Field.DisplayLabel := 'Entity';

    Field := TStringField.Create(FLookupDataset);
    Field.FieldName := 'FieldName';
    Field.Size := 64;
    Field.DataSet := FLookupDataset;
    Field.DisplayLabel := 'Field';

    Field := TIntegerField.Create(FLookupDataset);
    Field.FieldName := 'AddedBy';
    Field.DataSet := FLookupDataset;

    Field := TIntegerField.Create(FLookupDataset);
    Field.FieldName := 'LastUpdatedBy';
    Field.DataSet := FLookupDataset;

    Field := TDateTimeField.Create(FLookupDataset);
    Field.FieldName := 'DateAdded';
    Field.DataSet := FLookupDataset;

    Field := TDateTimeField.Create(FLookupDataset);
    Field.FieldName := 'LastUpdated';
    Field.DataSet := FLookupDataset;

  end;

  if not Assigned(FLookupValuesDataset) then
  begin
    FLookupValuesDataset := TXDataWebDataset.Create(nil);
    FLookupValuesDataset.EntitySetName := 'sxeLookupValue';

    Field := TIntegerField.Create(FLookupValuesDataset);
    Field.FieldName := 'LookupId';
    Field.Required := True;
    Field.DataSet := FLookupValuesDataset;
    Field.DisplayLabel := 'Lookup Id';

    Field := TStringField.Create(FLookupValuesDataset);
    Field.FieldName := 'LookupValue';
    Field.Size := 64;
    Field.Required := True;
    Field.DataSet := FLookupValuesDataset;
    Field.DisplayLabel := 'Lookup Value';

    Field := TIntegerField.Create(FLookupValuesDataset);
    Field.FieldName := 'SortOrder';
    Field.DataSet := FLookupValuesDataset;
    Field.DisplayLabel := 'Sort Order';

    Field := TStringField.Create(FLookupValuesDataset);
    Field.FieldName := 'Description';
    Field.Size := 255;
    Field.DataSet := FLookupValuesDataset;

    FLookupValuesDataset.OnNewRecord := ValuesNewRecord;
  end;

end;

destructor TEssentialsLookupManager.Destroy;
begin
  if Assigned(FLookupValuesDataset) then
  begin
    if FLookupValuesDataset.Active then
      FLookupValuesDataset.Close;
    FLookupValuesDataset.Free;
    FLookupValuesDataset := nil;
  end;

  if Assigned(FLookupDataset) then
  begin
    if FLookupDataset.Active then
      FLookupDataset.Close;
    FLookupDataset.Free;
    FLookupDataset := nil;
  end;

  inherited;
end;

function TEssentialsLookupManager.GetRegisteredFields(const AClassName: string): TList<string>;
var
  dto: TdtoLookupDef;
begin
  Result := nil;
  for dto in FRegisteredEntities do
  begin
    if dto.EntityClassName = AClassName then
    begin
      Result := dto.LookupFields;
      break;
    end;
  end;
end;

procedure TEssentialsLookupManager.Load;
begin
  CreateDatasets;
  LoadRegisteredEntities;
  LoadLookups;
end;

procedure TEssentialsLookupManager.LoadCombo(ACtrl: TDBComboBox);
var
  lField, lEntity: string;
begin
  lField := ACtrl.DataField;
  lEntity := 'T' + TXDataWebDataset(ACtrl.DataSource.DataSet).EntitySetName;
  if Await(LocateLookup(lEntity, lField)) then
  begin
    ACtrl.Items.Clear;
    FLookupValuesDataset.First;
    while not FLookupValuesDataset.Eof do
    begin
      ACtrl.Items.Add(FLookupValuesDataset.FieldByName('LookupValue').AsString);
      FLookupValuesDataset.Next;
    end;
  end;
end;

procedure TEssentialsLookupManager.LoadLookups;
begin
  Await(FLookupDataset.LoadAsync);
end;

procedure TEssentialsLookupManager.LoadLookupValueData;
var
  Info: TResolveResults;
begin
  FLookupValuesDataset.QueryString := '$filter=LookupId eq ' + FLookupDataset.FieldByName('Id').AsString;
  Info := Await(TResolveResults, FLookupValuesDataset.LoadAsync);
end;

procedure TEssentialsLookupManager.LoadRegisteredEntities;
const
  essentials_svc = 'IEssentialsService.SupportedLookupEntities';
var
  lRetval: TXDataClientResponse;
  lArray: TJSArray;
  lObject: TJSObject;
  I: Integer;
  LList: TList<TdtoLookupDef>;
  lDef: TdtoLookupDef;
begin
  lRetval := Await(TXDataClientResponse, FWebClient.RawInvokeAsync(essentials_svc, []));
  lArray := TXDataSvcUtils.AsArray(lRetval);

  LList := TList<TdtoLookupDef>.Create;
  try
    for I := 0 to lArray.Length - 1 do
    begin
      lDef := TdtoLookupDef.CreateFromJSON(lArray[I]);
      LList.Add(lDef);
    end;

    if Assigned(FRegisteredEntities) then
      FRegisteredEntities.Free;
    FRegisteredEntities := LList;
  except
    LList.Free;
    raise;
  end;
end;

function TEssentialsLookupManager.LocateLookup(const EntityClassName, FieldName: string): Boolean;
var
  V: TJSValueDynArray;
begin

  if (FLookupDataset.FieldByName('EntityClassName').AsString.ToUpper = EntityClassName.ToUpper) and
    (FLookupDataset.FieldByName('FieldName').AsString.ToUpper = FieldName.ToUpper) then
  begin
    Await(LoadLookupValueData);
    Exit(True);
  end;

  FLookupValuesDataset.Close;

  SetLength(V, 2);

  V[0] := EntityClassName;
  V[1] := FieldName;

  Result := FLookupDataset.Locate('EntityClassName;FieldName', V, [loCaseInsensitive]);
  if not Result then
  begin
    //Create a record
    FLookupDataset.Insert;
    FLookupDataset.FieldByName('EntityClassName').AsString := EntityClassName;
    FLookupDataset.FieldByName('FieldName').AsString := FieldName;
    FLookupDataset.FieldByName('DateAdded').AsDateTime := Now;
    FLookupDataset.Post;
    Await(SaveLookupChanges);
    Result := True;
  end;

  Await(LoadLookupValueData);
end;

function TEssentialsLookupManager.SaveLookupChanges: Boolean;
var
  Info: TResolveResults;
begin
  if TXDataDSUtils.CheckIsModified(FLookupDataset) then
  begin
    Info := Await(FLookupDataset.ApplyUpdatesAsync);
    { TODO : Check for errors }

    TXDataDSUtils.UpdateAllIds(FLookupDataset, Info, 'Id');
    Result := True;
  end
  else
    Result := True;
end;

function TEssentialsLookupManager.SaveValueChanges: Boolean;
var
  Info: TResolveResults;
begin
  if TXDataDSUtils.CheckIsModified(FLookupValuesDataset) then
  begin
    Info := Await(FLookupValuesDataset.ApplyUpdatesAsync);
    { TODO : Check for errors }
    Result := True;
  end
  else
    Result := True;
end;

procedure TEssentialsLookupManager.LoadLookupCombos(AForm: TForm);
var
  I: Integer;
  C, S: string;
begin
  for I := 0 to Aform.ControlCount - 1 do
  begin
    C := AForm.controls[I].ClassName;
    S := AForm.controls[I].Name;
    if (AForm.controls[I] is TDBComboBox) then
      LoadCombo(TDBComboBox(AForm.controls[I]));
  end;
end;

procedure TEssentialsLookupManager.SetWebClient(const Value: TXDataWebClient);
begin
  FWebClient := Value;
  FLookupDataset.Connection := FWebClient.Connection;
  FLookupValuesDataset.Connection := FWebClient.Connection;
  Load;
end;

procedure TEssentialsLookupManager.ValuesNewRecord(DataSet: TDataSet);
begin
  FLookupValuesDataset.FieldByName('LookupId').AsInteger := FLookupDataset.FieldByName('Id').AsInteger;
end;

{ TCustomNamesManager }

constructor TCustomNamesManager.Create;
begin
  CreateDataset;
end;

procedure TCustomNamesManager.CreateDataset;
var
  Field: TField;
begin
  if not Assigned(FNamesDataset) then
  begin
    FNamesDataset := TXDataWebDataset.Create(nil);
    FNamesDataset.EntitySetName := 'sxeCustomName';

    Field := TStringField.Create(FNamesDataset);
    Field.FieldName := 'EntityClassName';
    Field.Size := 64;
    Field.DataSet := FNamesDataset;
    Field.DisplayLabel := 'Entity';
    Field.Required := True;

    Field := TStringField.Create(FNamesDataset);
    Field.FieldName := 'FieldName';
    Field.Size := 64;
    Field.DataSet := FNamesDataset;
    Field.DisplayLabel := 'Field';
    Field.Required := True;

    Field := TStringField.Create(FNamesDataset);
    Field.FieldName := 'CustomName';
    Field.Size := 64;
    Field.DataSet := FNamesDataset;
    Field.DisplayLabel := 'CustomName';
    Field.Required := True;
  end;

end;

destructor TCustomNamesManager.Destroy;
begin
  if Assigned(FNamesDataset) then
  begin
    if FNamesDataset.Active then
      FNamesDataset.Close;
    FNamesDataset.Free;
    FNamesDataset := nil;
  end;

  inherited;
end;

function TCustomNamesManager.EntityCustomName(const EntityClassName: string): string;
begin
  Result := EntityFieldName(EntityClassName, 'Self');
  if Result = '' then
    Result := TUtils.SplitOnCaps(EntityClassName.Substring(1));
end;

function TCustomNamesManager.EntityFieldName(const EntityClassName, FieldName: string): string;
var
  V: TJSValueDynArray;
begin

  if (FNamesDataset.FieldByName('EntityClassName').AsString.ToUpper = EntityClassName.ToUpper) and
    (FNamesDataset.FieldByName('FieldName').AsString.ToUpper = FieldName.ToUpper) then
  begin
    Result := FNamesDataset.FieldByName('CustomName').AsString;
  end
  else
  begin

    SetLength(V, 2);

    V[0] := EntityClassName;
    V[1] := FieldName;

    if FNamesDataset.Locate('EntityClassName;FieldName', V, [loCaseInsensitive]) then
      Result := FNamesDataset.FieldByName('CustomName').AsString
    else
      Result := '';
  end;
end;

function TCustomNamesManager.GetRegisteredFields(const EntityClassName: string): TList<string>;
var
  dto: TdtoLookupDef;
begin
  Result := nil;
  for dto in FRegisteredEntities do
  begin
    if dto.EntityClassName = EntityClassName then
    begin
      Result := dto.LookupFields;
      break;
    end;
  end;
end;

procedure TCustomNamesManager.Load;
begin
  Await(LoadRegisteredEntities);
  Await(FNamesDataset.LoadAsync);
end;

procedure TCustomNamesManager.LoadRegisteredEntities;
const
  essentials_svc = 'IEssentialsService.SupportedCustomNamesEntities';
var
  lRetval: TXDataClientResponse;
  lArray: TJSArray;
  lObject: TJSObject;
  I: Integer;
  LList: TList<TdtoLookupDef>;
  lDef: TdtoLookupDef;
begin
  lRetval := Await(TXDataClientResponse, FWebClient.RawInvokeAsync(essentials_svc, []));
  lArray := TXDataSvcUtils.AsArray(lRetval);

  LList := TList<TdtoLookupDef>.Create;
  try
    for I := 0 to lArray.Length - 1 do
    begin
      lDef := TdtoLookupDef.CreateFromJSON(lArray[I]);
      LList.Add(lDef);
    end;

    if Assigned(FRegisteredEntities) then
      FRegisteredEntities.Free;
    FRegisteredEntities := LList;
  except
    LList.Free;
    raise;
  end;
end;

function TCustomNamesManager.SaveChanges: Boolean;
var
  Info: TResolveResults;
begin
  if TXDataDSUtils.CheckIsModified(FNamesDataset) then
  begin
    Info := Await(FNamesDataset.ApplyUpdatesAsync);
    { TODO : Check for errors }
    Result := True;
  end
  else
    Result := True;
end;

procedure TCustomNamesManager.SetCustomLabels(AForm: TForm);
var
  elId, fName: string;
begin
  fName := AForm.Name;
  fName := fName.ToLower;

  FNamesDataset.First;
  while not FNamesDataset.Eof do
  begin

    elId := fname + '.' +
      FNamesDataset.FieldByName('EntityClassName').AsString.Substring(1).ToLower + '.' +
      FNamesDataset.FieldByName('FieldName').AsString.ToLower + '.label';

    if TDocUtils.elementIdExists(elId) then
      TDocUtils.writeElementText(elId, FNamesDataset.FieldByName('CustomName').AsString);

    FNamesDataset.Next;
  end;
end;

procedure TCustomNamesManager.SetCustomTableTitles(const ATable: TDBTableControl);
var
  lClassName: string;
  lRegisteredFields: TList<string>;
  S: string;
  I: Integer;
begin
  lClassName := 'T' + TXDataWebDataset(ATable.DataSource.DataSet).EntitySetName;
  lRegisteredFields := GetRegisteredFields(lClassName);
  if not Assigned(lRegisteredFields) then
    Exit;

  for I := 0 to ATable.Columns.Count - 1 do
  begin
    S := EntityFieldName(lClassName, ATable.Columns[I].DataField);
    if S <> '' then
      ATable.Columns[I].Title := S;
  end;

end;

procedure TCustomNamesManager.SetWebClient(const Value: TXDataWebClient);
begin
  FWebClient := Value;
  FNamesDataset.Connection := FWebClient.Connection;
  Load;
end;

{ TNotesManager }

function TNotesManager.GetNoteData(const ANoteId: Integer): string;
const
  essentials_svc = 'IEssentialsService.GetNote';
var
  lRetval: TXDataClientResponse;
begin
  lRetval := Await(TXDataClientResponse, FWebClient.RawInvokeAsync(essentials_svc, [ANoteId]));
  Result := TXDataSvcUtils.AsString(lRetval);
end;

function TNotesManager.SaveNoteData(const ANoteId: Integer; const ANote: string): string;
const
  essentials_svc = 'IEssentialsService.SaveNote';
var
  lRetval: TXDataClientResponse;
begin
  lRetval := Await(TXDataClientResponse, FWebClient.RawInvokeAsync(essentials_svc, [ANoteId, ANote]));
  Result := TXDataSvcUtils.AsString(lRetval);
end;

procedure TNotesManager.SetWebClient(const Value: TXDataWebClient);
begin
  FWebClient := Value;
end;

{ TEssentialsAttributesManager }

constructor TEssentialsAttributesManager.Create;
begin
  CreateDatasets;
  //insert into DATA_ATTRIBUTE_DEF (Id, DATE_ADDED, ADDED_BY, LAST_UPDATED, LAST_UPDATED_BY, ENTITY_NAME, NAME, VALUE_KIND, MULTI_VALUE) Values (0, datetime('now'), 1, datetime('now'), 1, "EssentialsDemo1", "Phone", "Text", "T")
end;

procedure TEssentialsAttributesManager.CreateDatasets;
var
  field: TField;
begin
  if not Assigned(FAttributesDefinitionsDataset) then
  begin
    FAttributesDefinitionsDataset := TXDataWebDataset.Create(nil);
    FAttributesDefinitionsDataset.EntitySetName := 'sxeDataAttributeDef';

    Field := TIntegerField.Create(FAttributesDefinitionsDataset);
    Field.FieldName := 'Id';
    Field.DataSet := FAttributesDefinitionsDataset;

    Field := TStringField.Create(FAttributesDefinitionsDataset);
    Field.FieldName := 'Name';
    Field.DataSet := FAttributesDefinitionsDataset;

    Field := TStringField.Create(FAttributesDefinitionsDataset);
    Field.FieldName := 'EntityName';
    Field.DataSet := FAttributesDefinitionsDataset;

    Field := TStringField.Create(FAttributesDefinitionsDataset);
    Field.FieldName := 'ValueKind';
    Field.DataSet := FAttributesDefinitionsDataset;

    Field := TBooleanField.Create(FAttributesDefinitionsDataset);
    Field.FieldName := 'MultiValue';
    Field.DataSet := FAttributesDefinitionsDataset;

    Field := TIntegerField.Create(FAttributesDefinitionsDataset);
    Field.FieldName := 'AddedBy';
    Field.DataSet := FAttributesDefinitionsDataset;

    Field := TIntegerField.Create(FAttributesDefinitionsDataset);
    Field.FieldName := 'LastUpdatedBy';
    Field.DataSet := FAttributesDefinitionsDataset;

    Field := TDateTimeField.Create(FAttributesDefinitionsDataset);
    Field.FieldName := 'DateAdded';
    Field.DataSet := FAttributesDefinitionsDataset;

    Field := TDateTimeField.Create(FAttributesDefinitionsDataset);
    Field.FieldName := 'LastUpdated';
    Field.DataSet := FAttributesDefinitionsDataset;

    FAttributesDefinitionsDataset.OnNewRecord := DefinitionsNewRecord;
  end;
end;

destructor TEssentialsAttributesManager.Destroy;
begin

  if Assigned(FAttributesDefinitionsDataset) then
  begin
    if FAttributesDefinitionsDataset.Active then
      FAttributesDefinitionsDataset.Close;
    FAttributesDefinitionsDataset.Free;
    FAttributesDefinitionsDataset := nil;
  end;

  inherited;
end;

function TEssentialsAttributesManager.GetRegisteredFields(
  const EntityClassName: string): TList<string>;
var
  dto: TdtoLookupDef;
begin
  Result := nil;
  for dto in FRegisteredEntities do
  begin
    if dto.EntityClassName = EntityClassName then
    begin
      Result := dto.LookupFields;
      break;
    end;
  end;
end;

procedure TEssentialsAttributesManager.Load;
begin
  CreateDatasets;
  Await(LoadRegisteredEntities);
end;

procedure TEssentialsAttributesManager.LoadAttributeDefinitions;
var
  Info: TResolveResults;
begin
  FAttributesDefinitionsDataset.QueryString := '$filter=EntityName eq ' + QuotedStr(FSelectedEntity);
  Info := Await(TResolveResults, FAttributesDefinitionsDataset.LoadAsync);
end;

procedure TEssentialsAttributesManager.LoadRegisteredEntities;
const
  essentials_svc = 'IEssentialsService.SupportedAttributeEntities';
var
  lRetval: TXDataClientResponse;
  lArray: TJSArray;
  lObject: TJSObject;
  I: Integer;
  LList: TList<TdtoLookupDef>;
  lDef: TdtoLookupDef;
begin
  lRetval := Await(TXDataClientResponse, FWebClient.RawInvokeAsync(essentials_svc, []));
  lArray := TXDataSvcUtils.AsArray(lRetval);

  LList := TList<TdtoLookupDef>.Create;
  try
    for I := 0 to lArray.Length - 1 do
    begin
      lDef := TdtoLookupDef.CreateFromJSON(lArray[I]);
      LList.Add(lDef);
    end;

    if Assigned(FRegisteredEntities) then
      FRegisteredEntities.Free;
    FRegisteredEntities := LList;
  except
    LList.Free;
    raise;
  end;
end;


function TEssentialsAttributesManager.LocateAttributeDefinitions(const EntityClassName: string): Boolean;
var
  V: TJSValueDynArray;
begin
  if (FSelectedEntity <> '') and (FSelectedEntity.ToUpper = EntityClassName.ToUpper) then
  begin
    Await(LoadAttributeDefinitions);
    Exit(True);
  end;

  FAttributesDefinitionsDataset.Close;

  Await(LoadAttributeDefinitions);
  SetLength(V, 1);
  V[0] := EntityClassName;
  Result := FAttributesDefinitionsDataset.Locate('EntityName', V, [loCaseInsensitive]);
end;

function TEssentialsAttributesManager.SaveAttributeDefinitionChanges: Boolean;
var
  Info: TResolveResults;
begin
  if TXDataDSUtils.CheckIsModified(FAttributesDefinitionsDataset) then
  begin
    Info := Await(FAttributesDefinitionsDataset.ApplyUpdatesAsync);
    { TODO : Check for errors }
    TXDataDSUtils.UpdateAllIds(FAttributesDefinitionsDataset, Info, 'Id');
    Result := True;
  end
  else
    Result := True;
end;

procedure TEssentialsAttributesManager.SetWebClient(const Value: TXDataWebClient);
begin
  FWebClient := Value;
  FAttributesDefinitionsDataset.Connection := FWebClient.Connection;
  Load;
end;

procedure TEssentialsAttributesManager.DefinitionsNewRecord(Dataset: TDataSet);
begin
  FAttributesDefinitionsDataset.FieldByName('EntityName').AsString := FSelectedEntity;
  FAttributesDefinitionsDataset.FieldByName('DateAdded').AsDateTime := Now;
  FAttributesDefinitionsDataset.FieldByName('LastUpdated').AsDateTime := Now;
end;

end.

